import { Navigate } from "react-router";
import { useStores } from "../..";

const UserLoginWindow = () => {
  let appStores = useStores();

  appStores.mainWindowStore.onUserLoginOpen();

  return <Navigate to="/" replace />;
};

export default UserLoginWindow;
